<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    title="確認"
  >
    <template v-slot:body="{ ok, cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row class="pb-3">
              <strong>
                {{ confirmMessage }}
              </strong>
            </v-row>

            <!-- 削除確認画面 -->
            <div class="my-3">
              <v-row>
                <!-- 基本設定 -->
                <v-col cols="6">
                  <v-row>
                    <v-col>
                      <h3>基本設定</h3>
                    </v-col>
                  </v-row>
                  <div class="ml-2">
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="KDDI GPU Cloudご契約番号"
                          :value="cloudVnGpuDetail.cloudVnConnectCommon.mNumber"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="回線番号"
                          :value="cloudVnGpuDetail.enumber"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group label="品目">
                          <template #value>
                            <div class="ml-3">
                              {{
                                cloudVnGpuDetail.cloudVnConnectCommon
                                  .bandwidthType
                              }}({{
                                $filter.bandwidthTo(
                                  cloudVnGpuDetail.cloudVnConnectCommon
                                    .bandwidth
                                )
                              }})
                            </div>
                          </template>
                        </app-label-group>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="ロケーション"
                          :value="
                            $filter.enumTo(
                              cloudVnGpuDetail.cloudVnConnectCommon.location,
                              'location'
                            )
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="KBIテナントコード"
                          :value="
                            cloudVnGpuDetail.cloudVnConnectCommon.kbiTenantCode
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="備考"
                          :value="
                            $filter.emptyTo(
                              cloudVnGpuDetail.cloudVnConnectCommon.description,
                              '-'
                            )
                          "
                        />
                      </v-col>
                    </v-row>
                  </div>
                </v-col>

                <!--接続先VPN/VN -->
                <v-col cols="6">
                  <v-row>
                    <v-col>
                      <h3>接続先VPN/VN</h3>
                    </v-col>
                  </v-row>
                  <div class="ml-2">
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="VPN/VNコード"
                          :value="
                            cloudVnGpuDetail.cloudVnConnectCommon.vpnVnCode
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="仮想ネットワーク(VN)名"
                          :value="
                            cloudVnGpuDetail.cloudVnConnectCommon.vpnVnCode.startsWith(
                              'B'
                            )
                              ? '-'
                              : cloudVnGpuDetail.cloudVnConnectCommon.vnName
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="L2/L3"
                          :value="cloudVnGpuDetail.cloudVnConnectCommon.vnType"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="ルーティング種別"
                          :value="
                            cloudVnGpuDetail.cloudVnConnectCommon.routingType
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="AS番号"
                          :value="
                            cloudVnGpuDetail.cloudVnConnectCommon.asNumber
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="MD5キー"
                          :value="
                            $filter.emptyTo(
                              cloudVnGpuDetail.cloudVnConnectCommon.md5Key,
                              '-'
                            )
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="Maximum Prefix"
                          :value="
                            cloudVnGpuDetail.cloudVnConnectCommon.maximumPrefix
                          "
                        />
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-row>

              <v-row class="mt-2">
                <!--回線情報（Act）-->
                <v-col cols="6">
                  <v-row>
                    <v-col>
                      <h3>回線情報(Act)</h3>
                    </v-col>
                  </v-row>
                  <div class="ml-2">
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="VNコネクト番号"
                          :value="cloudVnGpuDetail.cloudVnConnectAct.wnumber"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="VNコネクト名"
                          :value="
                            cloudVnGpuDetail.cloudVnConnectAct.vnConnectName
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="有効/無効"
                          :value="
                            $filter.enumTo(
                              cloudVnGpuDetail.cloudVnConnectAct
                                .isVnConnectStatus,
                              'enable'
                            )
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="IF状態"
                          :value="
                            $filter.enumTo(
                              cloudVnGpuDetail.cloudVnConnectAct.ifStatus,
                              'cloudVn_ifStatus'
                            )
                          "
                        />
                      </v-col>
                    </v-row>
                  </div>
                </v-col>

                <!-- 回線情報（Sby） -->
                <v-col cols="6">
                  <v-row>
                    <v-col>
                      <h3>回線情報(Sby)</h3>
                    </v-col>
                  </v-row>
                  <div v-if="cloudVnGpuDetail.cloudVnConnectSby" class="ml-2">
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="VNコネクト番号"
                          :value="cloudVnGpuDetail.cloudVnConnectSby.wnumber"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="VNコネクト名"
                          :value="
                            cloudVnGpuDetail.cloudVnConnectSby.vnConnectName
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="有効/無効"
                          :value="
                            $filter.enumTo(
                              cloudVnGpuDetail.cloudVnConnectSby
                                .isVnConnectStatus,
                              'enable'
                            )
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="IF状態"
                          :value="
                            $filter.enumTo(
                              cloudVnGpuDetail.cloudVnConnectSby.ifStatus,
                              'cloudVn_ifStatus'
                            )
                          "
                        />
                      </v-col>
                    </v-row>
                  </div>
                  <div v-else class="ml-3">-</div>
                </v-col>
              </v-row>

              <v-row class="mt-2">
                <!-- ルーティング情報（Act） -->
                <v-col cols="6">
                  <v-row>
                    <v-col>
                      <h3>ルーティング情報(Act)</h3>
                    </v-col>
                  </v-row>
                  <div class="ml-2">
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="WANアドレス"
                          :value="cloudVnGpuDetail.cloudVnConnectAct.wanAddress"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="ピアIPアドレス"
                          :value="
                            cloudVnGpuDetail.cloudVnConnectAct.peerIpAddress
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="Local Preference"
                          :value="
                            $filter.enumTo(
                              cloudVnGpuDetail.cloudVnConnectAct
                                .localPreference,
                              'localPreference'
                            )
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="MED"
                          :value="
                            $filter.enumTo(
                              cloudVnGpuDetail.cloudVnConnectAct.med,
                              'med'
                            )
                          "
                        />
                      </v-col>
                    </v-row>
                  </div>
                </v-col>

                <!-- ルーティング情報（Sby） -->
                <v-col cols="6">
                  <v-row>
                    <v-col>
                      <h3>ルーティング情報(Sby)</h3>
                    </v-col>
                  </v-row>
                  <div v-if="cloudVnGpuDetail.cloudVnConnectSby" class="ml-2">
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="WANアドレス"
                          :value="cloudVnGpuDetail.cloudVnConnectSby.wanAddress"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="ピアIPアドレス"
                          :value="
                            cloudVnGpuDetail.cloudVnConnectSby.peerIpAddress
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="Local Preference"
                          :value="
                            $filter.enumTo(
                              cloudVnGpuDetail.cloudVnConnectSby
                                .localPreference,
                              'localPreference'
                            )
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="MED"
                          :value="
                            $filter.enumTo(
                              cloudVnGpuDetail.cloudVnConnectSby.med,
                              'med'
                            )
                          "
                        />
                      </v-col>
                    </v-row>
                  </div>
                  <div v-else class="ml-3">-</div>
                </v-col>
              </v-row>

              <v-row class="mt-2">
                <!-- カスタム経路集約情報 -->
                <v-col cols="12">
                  <v-row>
                    <v-col>
                      <h3>カスタム経路集約情報</h3>
                    </v-col>
                  </v-row>
                  <div class="ml-2">
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="経路集約"
                          :value="
                            cloudVnGpuDetail.cloudVnConnectCommon
                              .routeAggregation
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row
                      v-if="
                        cloudVnGpuDetail.cloudVnConnectCommon
                          .routeAggregation !== 'OFF'
                      "
                    >
                      <v-col>
                        <app-label-group label="経路集約アドレス">
                          <template #value>
                            <template
                              v-if="
                                cloudVnGpuDetail.cloudVnConnectCommon
                                  .routeAggregation === 'CUSTOM'
                              "
                            >
                              <div class="d-flex flex-wrap">
                                <span
                                  class="ml-3"
                                  v-for="(
                                    ip, index
                                  ) in sortedRouteAggregationAddressList"
                                  :key="index"
                                >
                                  {{ ip }}
                                </span>
                              </div>
                            </template>
                            <template
                              v-else-if="
                                cloudVnGpuDetail.cloudVnConnectCommon
                                  .routeAggregation === 'ON'
                              "
                            >
                              <span class="ml-3">0.0.0.0/0</span>
                            </template>
                          </template>
                        </app-label-group>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="ok" variant="flat" color="primary">はい</v-btn>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >いいえ</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { CloudVnGpuDetail } from "@/apis/CloudVnGpuApi";

export default defineComponent({
  name: "MultiCloudGpuVnConnectionDeleteConfirm",
  props: {
    cloudVnGpuDetail: {
      type: Object as PropType<CloudVnGpuDetail>,
      required: true,
    },
  },
  computed: {
    confirmMessage(): string {
      return "こちらの内容でクラウド接続向けVN回線を削除します。よろしいですか？";
    },
    /**
     * 経路集約アドレスリストを数値順（IPアドレス順）で昇順ソートして返す
     * @returns ソート済みの経路集約アドレスリスト
     */
    sortedRouteAggregationAddressList(): string[] {
      const list =
        this.cloudVnGpuDetail?.cloudVnConnectCommon
          ?.routeAggregationAddressList;
      if (Array.isArray(list)) {
        return list.sortIpAddress();
      }
      return Array.isArray(list) ? list : [];
    },
  },
  data() {
    return {};
  },
});
</script>

<style lang="scss" scoped></style>
